import { apiClient } from './api.client';

export const uploadFileService = {
  UploadFile,
};

function UploadFile(formData, path) {
  return apiClient.put(`/api/${path}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
